import React, { Fragment } from "react";
import {
  Row,
  Col,
  Button,
  Input,
  Card,
  Avatar,
  message,
  Icon,
  Tag,
  Tooltip,
  Alert,
  Popconfirm
} from "antd";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { push } from "connected-react-router";
import { Route, Switch, Link } from "react-router-dom";
import { API } from "aws-amplify";
import { sessionActions } from "redux/modules/session";
import SettingStoreConfig from "../settings-store-config";
import SettingsShipping from "../settings-shipping";
import * as Styled from "./styled";
import etsyLogo from "assets/etsy.svg";

class SettingsStore extends React.Component {
  state = {
    showtoken: false,
    loading: false,
    code: ""
  };

  componentWillMount() {
    this.onAuthInit();
  }

  onAuthInit = () => {
    this.setState({
      loading: true
    });
    API.get("api", "etsy/auth").then(
      resp => {
        this.setState({
          showtoken: false,
          loading: false,
          secret: resp.secret,
          oauth_token: resp.oauth_token,
          url: resp.url
        });
      },
      err => {
        this.setState({
          loading: false
        });
        message.error(err.response.data.message);
      }
    );
  };

  onOpenEtsy = () => {
    window.location.href = (this.state.url);
  };

  onCodeChange = e => {
    this.setState({
      code: e.target.value
    });
  };

  onSubmit = () => {
    this.setState({
      loading: true
    });
    API.post("api", "etsy/auth/validate", {
      body: this.state
    }).then(
      resp => {
        this.props.dispatch(sessionActions.setStore(resp));
        this.props.dispatch(push(`/settings/stores/${resp.storeId}/settings`));
        this.props.dispatch(sessionActions.selectStore(resp.storeId));
      },
      err => {
        console.log(err.response);
      }
    );
  };

  renderNoStores = () => {
    return (
      <Styled.NoStores>
        <p className="lead">You do not have any stores connected.</p>
        <Button
            loading={this.state.loading}
            type="primary"
            size="large"
            onClick={this.onOpenEtsy}
        >
          Connect with Etsy
        </Button>
      </Styled.NoStores>
    );
  };

  renderStoresList = stores => {
    return (
      <div>
        <Helmet title="My stores" />
        <h1>My Stores</h1>
        <Row>
          {stores.map(store => (
            <Col xs={24} md={8} lg={6} key={store.storeId}>
              <Card
                style={{ width: 300, marginTop: 16 }}
                actions={[
                  <Link to={`/settings/stores/${store.storeId}/settings`}>
                    <Icon type="setting" />
                  </Link>
                ]}
              >
                <Card.Meta
                  title={store.name}
                  avatar={<Avatar src={store.logoUrl || etsyLogo} />}
                />
                <Tag color="#2db7f5">{store.platform}</Tag>
                <Tooltip
                  title={`Auto order fulfill ${
                    store.autoFulfil ? "ON" : "OFF"
                  }`}
                >
                  <Icon
                    type="sync"
                    s
                    style={{
                      fontSize: 16,
                      color: store.autoFulfil ? "green" : "#999"
                    }}
                  />
                </Tooltip>
              </Card>
            </Col>
          ))}
        </Row>
        <Switch>
          <Route
            exact
            path="/settings/stores/:storeId/settings"
            component={SettingStoreConfig}
          />
        </Switch>
      </div>
    );
  };

  render() {
    const { stores } = this.props;
    return (
      <Styled.Container>
        {!stores.length ? this.renderNoStores() : this.renderStoresList(stores)}
      </Styled.Container>
    );
  }
}

export default connect(state => state.session)(SettingsStore);
